import type { Editor } from 'grapesjs'
import initializeStyles from './styles'

export function initializeStyleManager(editor: Editor) {
  // Initialize style manager configurations by adding new sectors
  initializeStyles(editor)
}

export default initializeStyleManager